module.exports = __webpack_public_path__ + "img/h_b_bg.dc761f66.png";